export const SERVER_TIMEZONE = 'UTC'
export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const SERVER_TIME_FORMAT = 'HH:mm'
export const CUSTOMER_FIELD_VARIABLE_TYPES = {
  SUBSCRIBER: 1,
  ACCOUNT: 2,
  MAILING: 3
}
export const CUSTOMER_FIELD_DATA_TYPES = {
  STRING: 1,
  INTEGER: 2,
  DATE: 3,
  BOOLEAN: 4,
  STRING_LIST: 5,
  CURRENCY: 6
}

export const MEDIAMANAGER_MODULE = 5
export const AB_TEST_MODULE = 9

export const EXTERNALIDP_MATCH_TYPES = [
  { name: 'sub', id: 1 },
  { name: 'preferredUsername', id: 2 },
]



// WEBPACK FOOTER //
// ./src/components/shared/const.js